import Create from "@mui/icons-material/Create";
import Language from "@mui/icons-material/Language";
import Newspaper from "@mui/icons-material/Newspaper";
import { Button } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

export const CreateContentLinks: FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Button
        href="/moments"
        data-analytics-id="create-content-from-scratch"
        size="small"
        variant="text"
        startIcon={<Create />}
      >
        {t("Communication from Scratch")}
      </Button>
      <Button
        href="/moments/newsletter"
        data-analytics-id="create-content-newsletter"
        size="small"
        variant="text"
        startIcon={<Newspaper />}
      >
        {t("Newsletter")}
      </Button>
      <Button
        href="/discover"
        data-analytics-id="create-content-newsletter"
        size="small"
        variant="text"
        startIcon={<Language />}
      >
        {t("Discover Library")}
      </Button>
    </>
  );
};
